export default __webpack_public_path__ + "static/bg_customers-db78715bdfdff314b16db654b315fa63.jpg";